// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  CheckRounded,
  ContentCopyRounded,
} from '@/constants/hardfin-standard-icons';
import { Box, IconButton, Tooltip } from '@mui/material';
import { MouseEvent, useState } from 'react';

interface Props {
  notes: string;
}

export function NotesCopyButton(props: Props) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyNotes = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(props.notes);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (error) {
      console.error('Failed to copy notes:', error);
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0.1rem',
        right: '0.1rem',
        zIndex: 1,
      }}
    >
      <Tooltip title={isCopied ? 'Copied!' : 'Copy notes'} arrow>
        <IconButton
          size="small"
          onClick={handleCopyNotes}
          aria-label={isCopied ? 'Copied' : 'Copy notes'}
          sx={{
            color: isCopied ? 'success.main' : 'action',
            transition: 'color 0.2s ease-in-out',
          }}
        >
          {isCopied ? (
            <CheckRounded fontSize="small" />
          ) : (
            <ContentCopyRounded fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
